import React from 'react';

export const LoanInterestConfig = [
  {
    param: 'interest_config',
    type: 'object',
    required: false,
        description: (
          <p>
            Payload to create a new interest config at loan creation (rather than before).
            Either <code>interest_config_id</code> or <code>interest_config</code> may be specified, but not both.
          </p>
        ),
    object: [
      {
        param: 'accrual_method',
        type: 'string',
        required: true,
        description: <p>The accrual method by which a loan will accrue interest. Possible values: <code>actual_360</code>, <code>actual_365</code>, and <code>actual_actual</code>.</p>,
      },
      {
        param: 'description',
        type: 'string',
        required: true,
        description: (
          <p>
            Description of the new interest config, up to 255 characters.
          </p>
        ),
      },
      {
        param: 'history',
        type: 'list',
        required: true,
        description: (
          <p>
            Set interest rates for different days. Refer to our Interest Config API for more details.
          </p>
        ),
        object: [
          {
            param: 'effective_date',
            type: 'string',
            required: false,
            description: (
              <p>
                The effective date for this interest rate configuration. Either <code>effective_date</code> or <code>effective_after_days</code> must be provided, but not both.
              </p>
            ),
          },
          {
            param: 'effective_after_days',
            type: 'number',
            required: false,
            description: (
              <p>
                The number of days after which this interest rate configuration becomes effective. Either <code>effective_date</code> or <code>effective_after_days</code> must be provided, but not both.
              </p>
            ),
          },
          {
            param: 'fixed_rate',
            type: 'number',
            required: false,
            description: (
            <p>
                This tier uses a fixed interest rate (e.g., <code>"0.045"</code> means <code>4.50%</code>, only zero or positive
                rates are allowed).{' '}
              </p>
            ),
          },
          {
            param: 'pivot_percentage',
            type: 'number',
            required: false,
            description: (
              <p>
                This tier uses a percentage of the pivot rate (e.g., <code>"0.85"</code> means <code>85%</code> of the pivot
                rate, only zero or positive percentages are allowed).
              </p>
            ),
          },
          {
            param: 'pivot_relative',
            type: 'number',
            required: false,
            description: (
            <p>
                This tier uses a premium or discount to the pivot rate (e.g., <code>"-0.015"</code> means pivot rate minus{' '}
                <code>1.50%</code>).
              </p>
            ),
          },
        ],
      },
    ],
  },
];
